import { render } from "./ColumnMapper.vue?vue&type=template&id=07eb2b54&scoped=true"
import script from "./ColumnMapper.vue?vue&type=script&lang=js"
export * from "./ColumnMapper.vue?vue&type=script&lang=js"

import "./ColumnMapper.vue?vue&type=style&index=0&id=07eb2b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07eb2b54"]])

export default __exports__